import { ClientDetailTemplate } from "../../Templates/ClientDetailTemplate";

export const ClientDetail = () => {
  return <ClientDetailTemplate />;
};
